import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ManageSalesRepService {

  constructor(private dataService: DataService) { }

  savemanageSalesRep(salesRep: any) {
    return this.dataService.post('/api/SalesRep/postmanageSalesRep', salesRep);
  };
  getmanageSalesRepList(FilterSearch: string) {
    return this.dataService.getRecordWithParams('/api/SalesRep/getmanageSalesRepDetailList', FilterSearch);
  };
  getmanageSalesRepById(SalesRepCode: number) {
    return this.dataService.getRecord('/api/SalesRep/getmanageSalesRepDetailById/?SalesRepCode=' + SalesRepCode);
  };
  deletemanageSalesRepById(SalesRepCode: number) {
    return this.dataService.getRecord('/api/SalesRep/deletemanageSalesRepDetailById/?SalesRepCode=' + SalesRepCode);
  };

  getRestrictEditbySalesRepCode(SalesRepCode: number) {
    return this.dataService.getRecord('/api/SalesRep/GetRestrictEditbySalesRepCode/?SalesRepCode=' + SalesRepCode);
  };
}
